import * as React from 'react';
import { cloneDeep } from 'lodash';
import { message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import {
  ParameterConfig,
  ParameterType,
  TrainingPhraseConfig,
  TrainingPhraseType
} from '@interface/index';
import { ReferenceTextArea, ReferenceTextRender, ValidataionResult } from '@component/index';
import '@style/component/response.less';
import './index.less';
import { localizedString } from '@locale/index';
import { isEqual, isStructAgent, ParameterMapStore } from '@lib/index';

export const VisibleTpComponents: { [key: string]: TrainingPhraseComp } = {};

export interface TraingingPhraseCompProps {
  globalKey?: string;
  style?: React.CSSProperties;
  agentId?: string;
  frameId: string;
  ownerId: string;
  ownerType: string;
  phraseType: string;
  label?: string;
  data: TrainingPhraseConfig[];
  parameters?: ParameterConfig[];
  update?: (next: TrainingPhraseConfig[], oriData: TrainingPhraseConfig[]) => void;
  placeholder?: string;
  placeholderFrist?: string;
  className?: string;
  borderTop?: boolean;
  disableChange?: boolean;
  noReference?: boolean;
  parameterMap: { [key: string]: ParameterConfig };
  isSingleLine?: boolean;
  allowClearAll?: Boolean;
  expressionValidation?: (expression: string) => ValidataionResult;
  forCompanionName?: string;
}

interface TrainingPhraseCompState {
  data: TrainingPhraseConfig[];
  realParams: ParameterConfig[];
  updateCount: number;
}

export class TrainingPhraseComp extends React.Component<
  TraingingPhraseCompProps,
  TrainingPhraseCompState
> {
  $wrap?: HTMLDivElement;
  $list?: HTMLUListElement;

  constructor(props: TraingingPhraseCompProps) {
    super(props);
    this.state = {
      data: [],
      realParams: [],
      updateCount: 0
    };
  }

  onInit = () => {
    const props = this.props;

    const nextData = (cloneDeep(props.data) || [])
      .filter((item: TrainingPhraseConfig) =>
        !item.toBeDeleted);
    nextData.reverse();

    if (!props.disableChange &&
      ((nextData.length &&
        nextData[0].trainingPhrase !== '') ||
        nextData.length === 0)
    ) {
      nextData.unshift({
        kind: 'TrainingPhraseConfig',
        id: '',
        agentId: props.agentId,
        frameId: props.frameId,
        ownerId: props.ownerId,
        ownerType: props.ownerType,
        phraseType: props.phraseType,
        label: props.label,
        trainingPhrase: ''
      });
    }

    let realParams = props.parameters || [];

    switch (props.phraseType) {
      case TrainingPhraseType.PROMPT_ANSWER: {
        const all = ParameterMapStore.all();
        for (const [k, v] of Object.entries(all)) {

          if (v.type === ParameterType.INTENT && v.name?.endsWith('PickValue')) {
            realParams = v.attributes || [];
            break;
          }
        }
      }
        break;
      case TrainingPhraseType.SLOT_UPDATE: {
        const all = ParameterMapStore.all();
        for (const [k, v] of Object.entries(all)) {
          if (v.type === ParameterType.INTENT && v.name?.endsWith('SlotUpdate')) {
            realParams = v.attributes || [];
            break;
          }
        }
      }
        break;
      case TrainingPhraseType.COMPANION_TRIGGER: {
        const all = ParameterMapStore.all();
        for (const [k, v] of Object.entries(all)) {
          if (v.type === ParameterType.INTENT && v.name?.endsWith(`Pick${props.forCompanionName}Value`)) {
            realParams = v.attributes || [];
            break;
          }
        }
      }
        break;
      default:
        break;
    }

    this.setState(prev => {
      return { realParams, data: nextData, updateCount: prev.updateCount + 1 };
    });
  }

  componentDidMount() {
    if (this.props.globalKey) {
      VisibleTpComponents[this.props.globalKey] = this;
    }

    this.onInit();
  }

  componentWillUnmount(): void {

    if (this.props.globalKey) {
      delete VisibleTpComponents[this.props.globalKey];
    }
  }

  componentDidUpdate(prevProps: any) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.onInit();
    }
  }

  render() {
    const {
      parameters = [],
      placeholder,
      placeholderFrist,
      className = '',
      borderTop = false,
      disableChange = false,
      noReference = false,
      parameterMap,
      isSingleLine = false,
      allowClearAll = false,
      style,
      expressionValidation
    } = this.props;

    const {
      data,
      realParams,
      updateCount
    } = this.state;

    return (
      <div
        ref={(wrap: HTMLDivElement) => {
          this.$wrap = wrap;
        }}
        style={style}
        className={`text-response__wrap exampler-wrapper`}
      >
        <ul
          ref={(list: HTMLUListElement) => {
            this.$list = list;
          }}
          className={`response__list text-response__list  ${data.length ? '' : 'disabled'}`}
          style={{
            borderTop: borderTop ? 'solid 1px rgba(0, 0, 0, 0.12)' : '',
            borderRadius: borderTop ? '4px' : ''
          }}
        >
          {data.length ? data.map(
            (trainingPhrase: TrainingPhraseConfig, index: number) => {
              return (
                <li
                  key={`text-response-${updateCount}-${index}`}
                >
                  <ReferenceTextArea
                    forList
                    forExpression
                    expressionValidation={expressionValidation}
                    key={`${trainingPhrase.id}-${index}`}
                    autoSize={true}
                    parameterMap={ParameterMapStore.all()}
                    initParameters={realParams.map(
                      (pm: ParameterConfig) => ({
                        id: pm.id,
                        name: pm.name,
                        type: pm.type,
                        promptQuestions: pm.promptQuestions,
                        proto: pm.proto,
                        attributes: pm.attributes,
                        parentId: pm.parentId,
                        triggers: pm.triggers
                      })
                    )}
                    placeholder={
                      (
                        index === 0
                          ? (placeholderFrist || placeholder)
                          : placeholder
                      ) || (
                        noReference
                          ? localizedString('text_response_placeholder')
                          : `Enter utterance templates`
                      )
                    }
                    disabled={disableChange ||
                      !!trainingPhrase.originKey || !!trainingPhrase.inheritedFromCompositeId}
                    className={`text-response__textarea ${className}`}
                    data={trainingPhrase.trainingPhrase}
                    update={(next: string) => {

                      if (next === trainingPhrase.trainingPhrase) {
                        return;
                      }
                      trainingPhrase.trainingPhrase = next;
                      this.handleBlur(trainingPhrase, index);
                    }}
                    onEnter={(value: string) => {

                      setTimeout(() => {
                        if (!isSingleLine) {
                          this.handleEnter();
                        }
                      }, 500);
                    }}
                  />
                  {/* <span>{index + 1}</span> */}
                  {disableChange ||
                    !!trainingPhrase.originKey ||
                    !!trainingPhrase.inheritedFromCompositeId ||
                    isSingleLine || data.length <= 1
                    || index === 0 ? (
                    ''
                  ) : (
                    <DeleteOutlined
                      style={{
                        color: 'rgba(0, 0, 0, 0.54)'
                      }}
                      onClick={() => {
                        const nextData = cloneDeep(data);
                        nextData.splice(index, 1);
                        this.setState({ data: nextData });
                        this.$update(nextData);
                      }}
                    />
                  )}
                </li>
              );
            }
          ) : <li>
            <ReferenceTextArea
              disabled
              forList
              expressionValidation={expressionValidation}
              data={''}
              placeholder={isStructAgent() ? localizedString('language_dependency_hint') : localizedString('text_response_placeholder')}
              initParameters={[]}
              parameterMap={{}}
              update={() => {
                // do nothing
              }}
              className={`text-response__textarea`}
            />
          </li>
          }
        </ul>
      </div >
    );
  }

  autoGen(value: string) {
    const { data } = this.state;
    const props = this.props;

    const next = cloneDeep(data);
    next[0] = {
      kind: 'TrainingPhraseConfig',
      id: '',
      agentId: props.agentId,
      frameId: props.frameId,
      ownerId: props.ownerId,
      ownerType: props.ownerType,
      phraseType: props.phraseType,
      label: props.label,
      trainingPhrase: value
    };

    this.setState({ data: next }, () => {
      this.$update(next);
    });
  }

  handleEnter = () => {
    const props = this.props;
    const { data } = this.state;

    const target: TrainingPhraseConfig[] = cloneDeep(data);

    // if (target[0].trainingPhrase !== '') {
    //   target.unshift({
    //     kind: 'TrainingPhraseConfig',
    //     id: '',
    //     agentId: props.agentId,
    //     frameId: props.frameId,
    //     ownerId: props.ownerId,
    //     ownerType: props.ownerType,
    //     phraseType: props.phraseType,
    //     label: props.label,
    //     trainingPhrase: ''
    //   });
    // }

    this.setState({ data: target }, () => {
      const doms: any = this.$list && this.$list.querySelectorAll(
        '.text-response__textarea textarea'
      );

      if (doms[0]) {
        doms[0].focus();
      }
    });
  };

  handleBlur = (value: TrainingPhraseConfig, index: number) => {
    const { data } = this.state;

    this.setState(prev => {
      return { updateCount: prev.updateCount + 1 };
    });

    const target: TrainingPhraseConfig[] = cloneDeep(data);

    const responseMap: { [key: string]: number } = {};

    target[index] = value;

    target.forEach((tp: TrainingPhraseConfig) => {
      if (!responseMap[tp.trainingPhrase]) {
        responseMap[tp.trainingPhrase] = 1;
      } else {
        responseMap[tp.trainingPhrase] += 1;
      }
    });

    if (responseMap[value.trainingPhrase] > 1) {
      message.warning(localizedString('text_response_repeated'));
      target.splice(index, 1);
    }

    this.setState({ data: target }, () => {
      this.$update(target);
    });
  };

  $update = (next: TrainingPhraseConfig[]) => {
    const { update } = this.props;

    const originData = this.props.data || [];
    const nextData = cloneDeep(next.filter((item: TrainingPhraseConfig) =>
      item.trainingPhrase !== ''));
    nextData.reverse();

    for (const oldItem of originData) {
      if (!next.find((item: TrainingPhraseConfig) =>
        item.id === oldItem.id)) {
        const delItem = {
          ...oldItem,
          toBeDeleted: true
        };
        nextData.push(delItem);
      }
    }

    if (update) {
      update(nextData, this.props.data);
    }
  };
}
